// Lightweight dropdown menu. On desktop, positions itself near the trigger.
// On mobile, opens as a bottom-sheet via the sheet primitive.

import { el } from './dom.js';
import { openSheet } from './sheet.js';

const MOBILE_QUERY = '(max-width: 767px)';

export function openMenu(triggerEl, items) {
  if (window.matchMedia?.(MOBILE_QUERY).matches) {
    return openMenuAsSheet(items);
  }
  return openMenuAsPopup(triggerEl, items);
}

function openMenuAsSheet(items) {
  const list = el('div', { class: 'menu-sheet-list' });
  let handle;
  for (const it of items) {
    if (it.separator) {
      list.append(el('div', { class: 'menu-separator' }));
      continue;
    }
    list.append(el('button', {
      role: 'menuitem',
      class: 'menu-sheet-item',
      onclick: () => { handle?.close(); it.onClick?.(); },
      disabled: it.disabled,
    }, [it.label]));
  }
  handle = openSheet({ kind: 'bottom', title: 'Actions', body: list });
  return { close: () => handle.close() };
}

function openMenuAsPopup(triggerEl, items) {
  document.querySelectorAll('.menu-popup').forEach((n) => n.remove());

  const rect = triggerEl.getBoundingClientRect();
  const popup = el('div', { class: 'menu-popup', role: 'menu' });
  for (const it of items) {
    if (it.separator) {
      popup.append(el('div', { class: 'menu-separator' }));
      continue;
    }
    const button = el('button', {
      role: 'menuitem',
      onclick: () => { close(); it.onClick?.(); },
      disabled: it.disabled,
    }, [it.label]);
    popup.append(button);
  }

  document.body.append(popup);

  const pw = popup.offsetWidth;
  const ph = popup.offsetHeight;
  let left = rect.left;
  if (left + pw > window.innerWidth - 8) left = window.innerWidth - pw - 8;
  if (left < 8) left = 8;
  let top = rect.top - ph - 6;
  if (top < 8) top = rect.bottom + 6;
  popup.style.left = `${Math.round(left)}px`;
  popup.style.top = `${Math.round(top)}px`;

  function close() {
    popup.remove();
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('mousedown', onDocDown, true);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function onDocDown(e) { if (!popup.contains(e.target) && e.target !== triggerEl) close(); }
  document.addEventListener('keydown', onKey, true);
  document.addEventListener('mousedown', onDocDown, true);

  return { close };
}
